const r = { aria_label: "Procurar", clear: "Limpar", placeholder_article: "", placeholder_header: "Procurar artigos" }, a = {
  searcher: r
};
export {
  a as default,
  r as searcher
};
//# sourceMappingURL=help-center-articles-search42.js.map
